import React from "react";
import { withTranslation } from "react-i18next";
import { NavigationLinkButton } from "./RegularComponents";

const GetHelp = ({ t }) => {
  return (
    <div className="row" style={{ paddingTop: "2em", paddingBottom: "2em" }}>
      <div className="col-xs-12">
        <b>{t("get_help.header")}</b>
      </div>
      <div className="col-xs-12">
        <i
          className="fas fa-phone-alt"
          style={{
            paddingRight: "5px"
          }}
          aria-hidden="true"
        ></i>
        <a href="tel:9024245200">902-424-5200</a> {t("get_help.or")}{" "}
        <a href="tel:18006704357">1-800-670-4357</a> {t("get_help.toll")}
      </div>
      <div className="col-xs-12">
        <i
          className="far fa-envelope"
          aria-hidden="true"
          style={{
            paddingRight: "5px"
          }}
        ></i>
        <NavigationLinkButton
          className="navigationLinkButtonHover"
          id="email-link"
          text={t("get_help.email")}
          onClick={() => {
            window.location.href =
              "mailto:askus@novascotia.ca?subject=Seniors%20Care%20Grants";
          }}
        />
      </div>
    </div>
  );
};

export default withTranslation("common")(GetHelp);
